export default "__VITE_ASSET__a7f878b7__"